import classnames from 'classnames';

import style from './CancelConfirmButtons.module.scss';

import { Button, ButtonTheme } from '@components/Button';
import { translate } from '@chaika/i18n/helper';

export interface CancelConfirmButtonsProps {
    dataTest?: string;
    confirmText?: string;
    cancelText?: string;
    withoutCancelButton?: boolean;
    additionalButtonText?: string;
    withoutSideMargins?: boolean;
    spaceBetween?: boolean;
    disableConfirmButton?: boolean;
    confirmButtonMessage?: string;
    disableCancelButton?: boolean;
    onConfirm(): void;
    onAdditionalButtonClick?(): void;
    onCancel(): void;
}

export function CancelConfirmButtons({
    confirmText,
    cancelText,
    dataTest = 'cancelConfirm',
    withoutSideMargins,
    spaceBetween,
    withoutCancelButton,
    additionalButtonText,
    disableConfirmButton,
    disableCancelButton,
    onAdditionalButtonClick,
    confirmButtonMessage,
    onConfirm,
    onCancel,
}: CancelConfirmButtonsProps) {
    const tConfirmText = confirmText ?? translate('yes');
    const tCancelText = cancelText ?? translate('no');

    return (
        <div
            className={classnames([
                style.root,
                withoutSideMargins && style.withoutSideMargins,
                spaceBetween && style.spaceBetween,
            ])}
        >
            <div className={style.button}>
                <Button
                    dataTest={`${dataTest}_confirm`}
                    disabled={disableConfirmButton}
                    theme={ButtonTheme.Primary}
                    onClick={onConfirm}
                >
                    {tConfirmText}
                </Button>
                {confirmButtonMessage && <div className={style.message}>{confirmButtonMessage}</div>}
            </div>
            {!withoutCancelButton && (
                <div className={style.button}>
                    <Button
                        dataTest={`${dataTest}_cancel`}
                        theme={ButtonTheme.Light}
                        disabled={disableCancelButton}
                        onClick={onCancel}
                    >
                        {tCancelText}
                    </Button>
                </div>
            )}
            {!!additionalButtonText && (
                <div className={classnames([style.button, style.additionalButton])}>
                    <Button
                        dataTest={`${dataTest}_additional`}
                        theme={ButtonTheme.Light}
                        onClick={onAdditionalButtonClick}
                    >
                        {additionalButtonText}
                    </Button>
                </div>
            )}
        </div>
    );
}
